export default __webpack_public_path__ + "static/0141-45511ad07e87ac83150497286c1b95dd.png";